export const formatCurrency = (value: number | string) => {
  if (typeof value === "string") {
    value = Number(value);
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};
